import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'

export type MachineLocationFormState = {
  name: string
  description: string
}

export const EMPTY_MACHINE_LOCATION_FORM: MachineLocationFormState = {
  name: '',
  description: '',
}

export function isMachineLocationFormValid(
  form: MachineLocationFormState
): boolean {
  return form.name.trim() !== '' && form.description.trim() !== ''
}

type MachineLocationFormDialogProps = {
  open: boolean
  title: string
  form: MachineLocationFormState
  nameLabel: string
  descriptionLabel: string
  saveLabel: string
  cancelLabel: string
  isPending: boolean
  onOpenChange: (open: boolean) => void
  onFormChange: (form: MachineLocationFormState) => void
  onSubmit: () => void
}

export function MachineLocationFormDialog({
  open,
  title,
  form,
  nameLabel,
  descriptionLabel,
  saveLabel,
  cancelLabel,
  isPending,
  onOpenChange,
  onFormChange,
  onSubmit,
}: MachineLocationFormDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className='space-y-4'>
          <div className='space-y-2'>
            <Label htmlFor='machine-location-name'>{nameLabel}</Label>
            <Input
              id='machine-location-name'
              value={form.name}
              disabled={isPending}
              onChange={(event) => {
                onFormChange({ ...form, name: event.target.value })
              }}
            />
          </div>
          <div className='space-y-2'>
            <Label htmlFor='machine-location-description'>
              {descriptionLabel}
            </Label>
            <Textarea
              id='machine-location-description'
              value={form.description}
              disabled={isPending}
              rows={4}
              onChange={(event) => {
                onFormChange({ ...form, description: event.target.value })
              }}
            />
          </div>
        </div>
        <DialogFooter>
          <Button
            type='button'
            variant='outline'
            disabled={isPending}
            onClick={() => onOpenChange(false)}
          >
            {cancelLabel}
          </Button>
          <Button
            type='button'
            disabled={!isMachineLocationFormValid(form) || isPending}
            onClick={onSubmit}
          >
            {saveLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
